export default "__VITE_ASSET__19862a29__"